var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"340"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"header-hint"},on),[_vm._v("\n      "+_vm._s(_vm.text)),_c('v-icon',{staticClass:"ml-1",attrs:{"x-small":""}},[_vm._v("info_outline")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.hint))])])}
var staticRenderFns = []

export { render, staticRenderFns }